import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

export default function Layout() {
  return (
    <div className="flex min-h-screen bg-background-50">
      <Sidebar />
      <main className="flex-1 flex flex-col min-w-0 lg:ml-0">
        {/* Top bar */}
        <header className="h-16 shrink-0 border-b border-background-200/70 bg-background-50 flex items-center justify-between px-4 md:px-6 sticky top-0 z-20">
          <div className="flex items-center gap-3 ml-10 lg:ml-0">
            <h2 className="text-sm font-medium text-foreground-700 hidden sm:block">
              <span className="text-foreground-400">İlkim Butik Otel</span>
              <span className="mx-2 text-foreground-300">/</span>
              <span className="font-heading">Yönetim Paneli</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-500 hidden sm:block">
              28 Temmuz 2026, Pazar
            </span>
            <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center cursor-pointer hover:bg-primary-200 transition-colors">
              <i className="ri-notification-3-line text-primary-600 text-sm"></i>
            </div>
          </div>
        </header>

        {/* Page content */}
        <div className="flex-1 p-4 md:p-6 overflow-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}